import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c04a72d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notion-form-container" }
const _hoisted_2 = { class: "notion-form-layout" }
const _hoisted_3 = { class: "notion-form-main" }
const _hoisted_4 = { class: "notion-form-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLoader = _resolveComponent("FormLoader")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_FormPanel = _resolveComponent("FormPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormLoader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.sideBar)
          ? (_openBlock(), _createBlock(_component_SideBar, {
              key: 0,
              id: _ctx.id,
              "route-key": _ctx.routeKey,
              item: _ctx.item,
              inputs: _ctx.sideBar
            }, null, 8, ["id", "route-key", "item", "inputs"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormPanel, {
              "route-key": _ctx.routeKey,
              id: _ctx.id ?? '0',
              "is-page": _ctx.getIsPage,
              "validation-schema": _ctx.getValidationSchema,
              inputs: _ctx.getFormMappingColumns,
              relationships: _ctx.getRelationships,
              values: _ctx.localValues,
              "onUpdate:values": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValues) = $event)),
              onSubmit: _ctx.submit,
              onInvalid: _ctx.onInvalidSubmit,
              onPreventEnter: _ctx.preventEnterSubmission,
              onAddNestedRow: _ctx.addNestedRow,
              onRemoveNestedRow: _ctx.removeNestedRow,
              onAddTier: _ctx.addTier,
              onRemoveTier: _ctx.removeTier
            }, null, 8, ["route-key", "id", "is-page", "validation-schema", "inputs", "relationships", "values", "onSubmit", "onInvalid", "onPreventEnter", "onAddNestedRow", "onRemoveNestedRow", "onAddTier", "onRemoveTier"])
          ])
        ])
      ])
    ])
  ], 64))
}